import * as React from 'react';

import withSequenceState from 'components/hoc/withSequenceState';
import Sequences from 'defs/sequences';

import { warn } from 'helper/debug';
import i18n from 'helper/i18n';

import Link from 'components/atoms/Link';
import ButtonBar from 'components/molecules/ButtonBar';
import CardLike from 'components/molecules/Card/elements/Like';
import ContentVideo from 'components/molecules/ContentVideo';
import Rich from 'components/molecules/Rich';
import ContentImageSlider from 'components/molecules/Slider/ContentImageSlider';

import { LinkProps } from 'components/atoms/Link';
import { CardDetailType } from 'components/molecules/Card/Detail/CardDetailTypes';
import { ContentImageProps } from 'components/molecules/ContentImage';
import { ContentVideoProps } from 'components/molecules/ContentVideo';

export type CardDetailTipProps = CardDetailType & {
	title: string;
	isDone: boolean;
	richText?: string;
	link?: LinkProps;
	images?: ContentImageProps[];
	contentVideo?: ContentVideoProps;
	doComplete: (id: number) => void;
	isSequenceLoading: boolean;
	favorite: boolean;
};

export class CardDetailTip extends React.Component<CardDetailTipProps> {
	public static displayName = 'CardDetailTip';

	public handleButtonClicks = (buttonType: string) => {
		if (this.props.isSequenceLoading) {
			return;
		}

		switch (buttonType) {
			case 'completed':
				this.props.onComplete({
					type: 'tip',
					onAnimationDone: () => {
						this.props.doComplete(this.props.id);
					},
				});
				break;
			default:
				warn(`Button Action "${buttonType}" not available`);
		}
	};

	public renderButtonBar = () => {
		const { isDone, isCheckable, isSequenceLoading, isUiCompleting } = this.props;
		let cardButtons: any = null;

		if (!isCheckable) {
			return null;
		}

		if (!isDone) {
			cardButtons = {
				buttons: [
					{
						knob: {
							modifier: 'dashed',
							size: 'l',
							icon: 'completed',
						},
					},
				],
			} as any;
		}

		if (cardButtons === null) {
			return null;
		}

		return (
			<div className="m-card__button-bar">
				<ButtonBar
					loading={isUiCompleting}
					disabled={isSequenceLoading}
					handleButtonClicks={this.handleButtonClicks}
					buttons={cardButtons.buttons}
				/>
			</div>
		);
	};

	public render() {
		const {
			title,
			images,
			contentVideo,
			richText,
			link,
			favorite,
			handleCardContentClick,
			handleShowDetailsClick,
			handleToggleFavorite,
		} = this.props;

		return (
			<div>
				<div className="m-card__content" onClick={handleCardContentClick}>
					<div className="m-card__info m-card__info--has-like">
						{title && <h4 className="m-card__info-title">{title}</h4>}
						<CardLike onClick={handleToggleFavorite} liked={favorite} />
					</div>
					<div className="m-card__link js-m-card__link">
						<Link
							onClick={handleShowDetailsClick}
							title={i18n('react.impulsCoach.components.cardDetail.tip.linkText')}
							modifier="button"
							openInNewWindow={false}
							iconRight={null}
						/>
					</div>
					<div className="m-card__detail">
						{richText && <Rich contents={richText} />}
						<ContentImageSlider id={title} images={images} />
						{contentVideo && <ContentVideo caption={contentVideo.caption} video={contentVideo.video} />}
						{link && (
							<Link title={link.title} externalHref={link.href} openInNewWindow={link.openInNewWindow} />
						)}
					</div>
					{this.renderButtonBar()}
				</div>
			</div>
		);
	}
}

export default withSequenceState(CardDetailTip, [Sequences.CARD_IS_CHECKING]);
